import { BaseBean } from './BaseBean';
import { PlanBean } from './PlanBean';


export class  ConfiguracionPlanBean extends BaseBean {

   public id:number;
   public nombre:string;
   public nivel:number;
   public plan:PlanBean;
   public ultimoNivel:Boolean;
   public objetivos: any[];

}
